'use client';
import React__default from 'react';
import { Dialog } from 'radix-ui';
import { Icon as IconMemo } from '../Icon/index.js';
import { IconSize } from '../../lib/constants.js';
import { isCustomSize, isEnumSize } from './types.js';
import classnames from 'classnames';
import styles from './index.module.scss.js';

const FullModal = ({ children, open = false, onClose, withClose = true, title, inset = false, actions, headerCta, size = 'large', overflowHidden, }) => {
    const handleIsOpen = (isOpen) => {
        if (!isOpen) {
            onClose();
        }
    };
    const sizeClassname = isEnumSize(size) && styles[size];
    const customStyle = isCustomSize(size)
        ? {
            '--modal-max-width': size.w,
            '--modal-max-height': size.h,
        }
        : undefined;
    const dialogBodyClassname = classnames(styles.dialogBody, {
        [styles.inset]: inset,
        [styles.overflowHidden]: overflowHidden,
    });
    const hideHeader = !title && !headerCta && !withClose;
    return (React__default.createElement(Dialog.Root, { open: open, onOpenChange: handleIsOpen },
        React__default.createElement(Dialog.Portal, null,
            React__default.createElement(Dialog.Overlay, { className: styles.overlay }),
            React__default.createElement(Dialog.Content, { className: classnames(styles.content, sizeClassname), style: customStyle },
                !hideHeader && (React__default.createElement("header", { className: `${styles.header} subheading` },
                    withClose && (React__default.createElement(Dialog.Close, { "aria-label": "Chiudi il dialogo", className: styles.closeButton },
                        React__default.createElement(IconMemo, { iconSize: IconSize.MD, name: "Close" }))),
                    headerCta && (React__default.createElement("span", { className: styles.headerCta }, headerCta)),
                    React__default.createElement(Dialog.Title, { className: styles.title }, title))),
                typeof children === 'string' ? (React__default.createElement(Dialog.Description, { className: dialogBodyClassname }, children)) : (React__default.createElement("div", { className: dialogBodyClassname }, children)),
                actions && React__default.createElement("footer", { className: styles.footer }, actions)))));
};

export { FullModal };
//# sourceMappingURL=index.js.map
